module.exports = __webpack_public_path__ + "img/woman.54c16f21.svg";